(function() {
  'use strict';

  angular
    .module('NozzleSelector.services')
    .factory('i18nService', i18nService);

  /* @ngInject */
  function i18nService($http) {

    function getLanguages() {
      return $http.get('./resources/languages.json');
    }

    return {
      getLanguages: getLanguages
    };
  }

}());
